const _excluded = ["expanded"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { ChevronDownButton } from './ChevronDownButton';
import { ChevronUpButton } from './ChevronUpButton';
export function ToggleVerticalChevronButton(_ref) {
  let {
      expanded
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  if (![true, false].includes(expanded)) {
    console.error('The "expanded" state property is required for the ToggleVerticalChevronButton component.');
  }
  return expanded ? /*#__PURE__*/React.createElement(ChevronUpButton, props) : /*#__PURE__*/React.createElement(ChevronDownButton, props);
}